import {
  Book,
  Boxes,
  CheckSquare,
  FileText,
  Hammer,
  LayoutDashboard,
  ListTodo,
  LucideIcon,
  MapPin,
  Truck,
  UserCog,
  Wrench,
} from 'lucide-react';

/**
 * Icons a pin may reference. Pins are stored in the database as plain JSON, so
 * the icon travels as a key rather than a component reference. Keys are looked
 * up by identity when pinning, so adding an icon here is all that is needed to
 * make it survive a round-trip.
 */
export const NAV_ICONS = {
  Book,
  Boxes,
  CheckSquare,
  FileText,
  Hammer,
  LayoutDashboard,
  ListTodo,
  MapPin,
  Truck,
  UserCog,
  Wrench,
} satisfies Record<string, LucideIcon>;

export type NavIconName = keyof typeof NAV_ICONS;

/** Reverse-lookup the registry key for an icon component. */
export function navIconName(icon?: LucideIcon): NavIconName | undefined {
  if (!icon) return undefined;
  return (Object.keys(NAV_ICONS) as NavIconName[]).find(
    (name) => NAV_ICONS[name] === icon,
  );
}

/**
 * Resolve a stored key back to a component. Unknown keys get nothing rather
 * than a generic pin glyph: a row of pin icons next to a project's book icon
 * reads as a mix of two meanings instead of one list.
 */
export function getNavIcon(name?: string): LucideIcon | undefined {
  return NAV_ICONS[name as NavIconName];
}
